export default {
    echarts: require('echarts')
}